/**
 * All possible label for Offer Summary Card
 */
export enum OfferSummaryCardLabel {
    Duration = 'Mindestlaufzeit $duration Monate',
    PriceOnce = 'Einmal',
    PriceMonthly = 'Pro Monat',
    PriceContinuous = 'Dauerhalt',
    PriceStairway = 'Ab dem $month. Monat',
    PibLink = 'Produktinformationsblatt',
}

/**
 * Price conditionBefore values for Offer Summary Card
 */
export enum OfferSummaryCardConditionBefore {
    PriceOnce = 'ab',
    None = '',
}

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Minimum downloads for the tariffs
 */
export enum TariffMinimumDownload {
    'DSL-IP-250000-TW' = 175,
    'DSL-IP-100000-TW' = 54,
    'DSL-IP-50000-TW' = 28,
    'DSL-IP-16000-TW' = 6,
}
/* eslint-enable @typescript-eslint/naming-convention */
